"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelect = void 0;
const FilledInput_1 = require("@mui/material/FilledInput");
const OutlinedInput_1 = require("@mui/material/OutlinedInput");
const Select_1 = __importDefault(require("@mui/material/Select"));
const styles_1 = require("@mui/material/styles");
exports.StyledSelect = (0, styles_1.styled)(Select_1.default)(({ theme }) => ({
    [`.${FilledInput_1.filledInputClasses.root}`]: {
        backgroundColor: theme.colours.white,
        borderRadius: "4px",
        border: `1px solid ${theme.colours.storm}`,
        "&:hover": {
            borderColor: theme.colours.slate
        },
        "&::before": {
            content: "''"
        },
        "&::after": {
            content: "''"
        },
        ".Mui-focused": {
            borderColor: theme.colours.inter,
            boxShadow: `0 0 0 1px ${theme.colours.inter}`,
            ".Mui-error": {
                boxShadow: `0 0 0 1px ${theme.colours.error400}`
            }
        },
        ".Mui-error": {
            borderColor: theme.colours.error400
        }
    },
    ".Mui-disabled": {
        border: `1px solid ${theme.colours.storm}9c`,
        color: `${theme.colours.slate}9c`,
        [`.${OutlinedInput_1.outlinedInputClasses.notchedOutline}`]: {
            border: 0
        },
        "&:hover": {
            borderColor: `${theme.colours.storm}9c`,
            color: `${theme.colours.slate}9c`
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlbGVjdC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMkRBQStEO0FBQy9ELCtEQUFtRTtBQUNuRSxrRUFBNkM7QUFDN0MsaURBQThDO0FBRWpDLFFBQUEsWUFBWSxHQUFHLElBQUEsZUFBTSxFQUFDLGdCQUFTLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDNUQsQ0FBQyxJQUFJLGdDQUFrQixDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDL0IsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztRQUNwQyxZQUFZLEVBQUUsS0FBSztRQUNuQixNQUFNLEVBQUUsYUFBYSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRTtRQUMxQyxTQUFTLEVBQUU7WUFDVCxXQUFXLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1NBQ2pDO1FBQ0QsV0FBVyxFQUFFO1lBQ1gsT0FBTyxFQUFFLElBQUk7U0FDZDtRQUNELFVBQVUsRUFBRTtZQUNWLE9BQU8sRUFBRSxJQUFJO1NBQ2Q7UUFDRCxjQUFjLEVBQUU7WUFDZCxXQUFXLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1lBQ2hDLFNBQVMsRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFO1lBQzdDLFlBQVksRUFBRTtnQkFDWixTQUFTLEVBQUUsYUFBYSxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRTthQUNqRDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osV0FBVyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtTQUNwQztLQUNGO0lBQ0QsZUFBZSxFQUFFO1FBQ2YsTUFBTSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLElBQUk7UUFDNUMsS0FBSyxFQUFFLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLElBQUk7UUFDakMsQ0FBQyxJQUFJLG9DQUFvQixDQUFDLGNBQWMsRUFBRSxDQUFDLEVBQUU7WUFDM0MsTUFBTSxFQUFFLENBQUM7U0FDVjtRQUNELFNBQVMsRUFBRTtZQUNULFdBQVcsRUFBRSxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxJQUFJO1lBQ3ZDLEtBQUssRUFBRSxHQUFHLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxJQUFJO1NBQ2xDO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9